// extracted by mini-css-extract-plugin
export default {"container":"offering-intro-module--container--We7fy","description":"offering-intro-module--description--uAy8Q"};